// removed by extract-text-webpack-plugin
module.exports = {"header":"_1D-fcmytPtTlJPE6","logo":"_3kqrOgp9svXo7ZdO","project":"_2cSKCsdjWOKSpUyi","description":"_2CeO0f2qXpxogznM"};


//////////////////
// WEBPACK FOOTER
// ./app/components/Auth/Login.pcss
// module id = 461
// module chunks = 1